import React, { Component } from 'react';

import { Seo } from '../../components/shared/wrappers/seo/Seo'
import NewsListComponent from '../../components/news/components/news-list/NewsListComponent';
// Schedule is hidden until the radio server is migrated
// import { ScheduleTableComponent } from '../../components/shared/schedule/components/schedule/ScheduleComponent';

import { BASIC_SEO_IMG, SEO_DEFAULTS } from '../../components/shared/constants';

import './StartPageComponent.scss';

const INDEX_SEO_TITLE = SEO_DEFAULTS.pages['/'].title;
const INDEX_SEO_DESCRIPTION = SEO_DEFAULTS.pages['/'].description;

export class StartPageComponent extends Component {
    render() {
        return (
            <div className='start-page-container'>
                <Seo meta={{
                        title: INDEX_SEO_TITLE,
                        description: INDEX_SEO_DESCRIPTION,
                        thumbnail: BASIC_SEO_IMG
                    }}
                />
                <NewsListComponent isStartPage={ true }/>
                {/* <ScheduleTableComponent /> */}
            </div>
        );
    }
}

export default StartPageComponent;